<div class="row no-gutters p-2 mx-5 mt-3">
        <div class="col" *ngIf="model">
            <strong class="text-dimmed" translate>GroupClassDetails.WaitListHeader</strong>
            <div class="pb-3 text-dimmed">
                <div *ngIf="waitListModel">
                    <div class="row">
                        <div class="col">
                            <div *ngFor="let item of waitListModel.items; let i = index">{{ i + 1 }}. {{ item.fullName }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-greyed-out" *ngIf="waitListModel && waitListModel.items.length == 0" translate>
                    GroupClassDetails.NoWaitListYet
                </div>
                <bcu-local-spinner [size]="25" [visible]="!waitListModel" *ngIf="!waitListModel">
                </bcu-local-spinner>
            </div>
        </div>
    </div>
